export const news = state => state.news


// WEBPACK FOOTER //
// ./src/store/getters.js